export default "__VITE_ASSET__5zZDp8hr__"